
import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { APIResponse } from "src/app/core/models/api-response";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { ISupplier } from "../models/suppliers.models";
import { IPageCount } from "src/app/shared/models/page.model";

@Injectable({
  providedIn: 'root',
})
export class SuppliersService {

  constructor(private http: HttpClient) {}

  public listAllSuppliers(page: IPageCount, search: string | undefined ): Observable<APIResponse<ISupplier>> {
    const params = new HttpParams()
      .set('page', page.number)
      .set('limit', page.size)
      .set('key', search!);

    return this.http.get<APIResponse<ISupplier>>(environment.BASE_URL_API + 'suppliers', { params });
  }

  public addSupplier(supplier: ISupplier): Observable<APIResponse<ISupplier>> {
    return this.http.post<APIResponse<ISupplier>>(
        environment.BASE_URL_API + 'suppliers',
        supplier
    );
  }
}
